import { useState } from "react";
import { Menu, X, ShoppingCart } from "lucide-react";
import { COMPANY } from "@/data/products";

const LINKS = [
  { label: "Home", href: "#home" },
  { label: "About Us", href: "#about" },
  { label: "Products", href: "#products" },
  { label: "Supplier Partnerships", href: "#suppliers" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar({ cartCount, onCartOpen }) {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-white/95 backdrop-blur border-b border-[#e6e1d8]" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 md:h-20 flex items-center justify-between gap-4">
        <a href="#home" className="flex items-center gap-3 shrink-0" data-testid="navbar-logo">
          <img src="/assets/logo.png" alt="VIGO SOLUTIONS SDN. BHD. logo" className="h-10 md:h-12 w-auto object-contain" />
        </a>

        <nav className="hidden lg:flex items-center gap-8" data-testid="navbar-links">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm font-semibold tracking-wide text-[#10233f] hover:text-[#0d7a72] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            onClick={onCartOpen}
            data-testid="nav-cart-button"
            aria-label="Open cart"
            className="relative p-2.5 rounded-full bg-[#0a1e3c] text-white hover:bg-[#0d7a72] transition-colors"
          >
            <ShoppingCart className="w-5 h-5" />
            {cartCount > 0 && (
              <span
                data-testid="nav-cart-count"
                className="absolute -top-1.5 -right-1.5 min-w-[20px] h-5 px-1 rounded-full bg-[#0d7a72] text-white text-xs font-bold flex items-center justify-center"
              >
                {cartCount}
              </span>
            )}
          </button>
          <button
            className="lg:hidden p-2 text-[#10233f]"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
            data-testid="nav-menu-toggle"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <nav className="lg:hidden border-t border-[#e6e1d8] bg-white px-4 py-3 flex flex-col" data-testid="navbar-mobile-menu">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="py-3 text-sm font-semibold text-[#10233f] border-b border-[#efece6] last:border-0"
            >
              {l.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}

export { LINKS, COMPANY };
